export default __webpack_public_path__ + "edff8810323965ea12c5c947d2e892e2.svg";